import React, { memo } from "react";

function ConfidencePill({ score, showHotIcon = false }) {
  const pct = Math.round(score * 100);
  let bgClass = "bg-[var(--color-text)]";
  if (score >= 0.5) {
    bgClass = "bg-[var(--color-primary)]";
  } else if (score >= 0.35) {
    bgClass = "bg-[var(--color-accent-amber)]";
  } else {
    bgClass = "bg-[var(--color-accent-red)]";
  }

  return (
    <div className="relative inline-flex items-center justify-center">
      {showHotIcon && (
        <span
          aria-label="Large lead over second rank"
          title="Large lead over second rank"
          className="absolute right-full mr-1.5 text-base leading-none"
        >
          🔥
        </span>
      )}
      <span
        className={`tabular inline-block px-2.5 py-1 rounded-full md:text-xs text-[10px] font-bold text-black min-w-10 text-center ${bgClass}`}
      >
        {pct}%
      </span>
    </div>
  );
}

export default memo(ConfidencePill);
